import {pxToRem} from '../../../utills/pxToRem'

export const storeAddressCardsWrapper = {
    display: 'grid',
    gridTemplateColumns: ['repeat(1, 1fr)', 'repeat(1, 1fr)', 'repeat(2, 1fr)', 'repeat(2, 1fr)'],
    columnGap: [pxToRem(40), pxToRem(40), pxToRem(40), pxToRem(40)],
    rowGap: [pxToRem(10), pxToRem(10), pxToRem(10), pxToRem(10)]
}

export const storeAddressText = {
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(13), pxToRem(13)],
    marginBottom: 0,
    lineHeight: 'normal'
}
